import { ValidationResult } from '../../../@types/validation-types'

export const emptyValidationMassages: ValidationResult = {
  address: {
    fields: {
      street: undefined,
      houseNumber: undefined,
      postcode: undefined,
      city: undefined,
      manualCity: [],
      manualQuarter: [],
      manualRegion: [],
      manualCountry: [],
    },
    validated: false,
  },
  basicInfo: {
    fields: {
      buildingType: undefined,
      mainFloorSpace: undefined,
      separableSpace: undefined,
      deposit: undefined,
      additionalCosts: undefined,
    },
    validated: false,
  },
  costs: {
    fields: {
      additionalCosts: undefined,
      deposit: undefined,
    },
    validated: false,
  },
  description: {
    fields: {
      adTitle: undefined,
      adDescription: undefined,
      adLocation: undefined,
      adOther: undefined,
      adFurnishingNote: undefined,
    },
    validated: false,
  },
  contactInfo: {
    fields: {
      salutation: undefined,
      lastName: undefined,
      phoneNumber: undefined,
      email: undefined,
    },
    validated: false,
  },
  multimedia: {
    validated: false,
  },
  otherFacilities: {
    fields: {
      totalFloorsNumber: undefined,
      parkingSpaceRent: undefined,
      noParkingSpaces: undefined,
      loadLiftingValue: undefined,
      noBathrooms: undefined,
      floor: undefined,
      minimumTermOfLease: undefined,
      rentalIncome: undefined,
      noBedrooms: undefined,
    },
    validated: false,
  },
  connections: {
    fields: {
      distanceToPT: undefined,
      distanceToMRS: undefined,
      distanceToFM: undefined,
      distanceToAirport: undefined,
    },
    validated: false,
  },
  construction: {
    fields: {
      constructionLastModernization: undefined,
      constructionYear: undefined,
      thermalCharacteristic: undefined,
    },
    validated: false,
  },
  tenantDocuments: {
    fields: {
      selfReport: undefined,
      solvency: undefined,
      rental: undefined,
      identification: undefined,
      income: undefined,
    },
    validated: false,
  },
  whoWeLookFor: {
    validated: true,
    fields: {
      requestedGender: [],
      numberOfRequestedFlatMates: [],
      ageOfRequestedFrom: [],
      ageOfRequestedTo: [],
      flatShareSize: [],
      numberOfMaleFlatMates: [],
      numberOfFemaleFlatMates: [],
      ageOfFlatMatesFrom: [],
      ageOfFlatMatesTo: [],
    },
  },
  flatShareRoomProperties: {
    fields: {},
    validated: true,
  },
  apiSearchData: {
    fields: {
      searchField1: [],
      searchField2: [],
      searchField3: [],
    },
    validated: true,
  },
  realtorLeadEngine: {
    validated: true,
    fields: {
      conversionToLeadAllowed: [],
    },
  },
  objectNumbers: {
    validated: true,
    fields: {
      externalId: [],
      groupNumber: [],
    },
  },
  objectDetails: {
    fields: {
      floor: undefined,
      totalFloorsNumber: undefined,
      constructionCondition: undefined,
      heatingType: undefined,
      wbsRequired: undefined,
    },
    validated: false,
  },
}
